import request from './request';

const panorama_nodes = {
	async getPanoramaNodes(query) {
		const response = await request.get('/app/panorama-nodes', query);
		return response;
	},
	async getPanoramaNodeById(query) {
		const response = await request.get('/app/panorama-nodes/id', query);
		return response;
	}
};

export default panorama_nodes;
